import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {featuresSetupSetSearchTerm} from "../../FeaturesSetup/featuresActions";


const PricingFiltersSearchInput = (props) => {

  const {featuresSetupSetSearchTerm, searchTerm, theme} = props;

  const handleInputChange = async (event) => {
    featuresSetupSetSearchTerm(event.target.value);
  }

  return (
    <input className={"radius-5 text-left width-100 margin-b16 "
      + (theme === "light" ? "generic-popup-textbox h-2" : "ui-input ui-input--gray4 ui-input--gray4--small")}
           value={searchTerm}
           onChange={handleInputChange}
           type="search"
           placeholder="Search"/>
  )
};

PricingFiltersSearchInput.propTypes = {
  theme: PropTypes.string,
}

const mapStateToProps = (store) => {
  const {searchTerm} = store.featuresSetupState;

  return {
    searchTerm,
  };
};

const mapDispatchToProps = {
  featuresSetupSetSearchTerm,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingFiltersSearchInput);
